import React, {ChangeEvent, useState} from "react";

import {Button, Input} from "@chakra-ui/react";

import {TpiGroupDto} from "./api/dtos";

import TpiGroupGauge from "./tpi-group-gauge";

function AutomatedTpiGroupResult() {
    const [value, setValue] = useState<string>("");
    const [response, setResponse] = useState<TpiGroupDto | null>(null);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
    }

    const onSubmit = async () => {
        if (value) {
            const parsedResponse: TpiGroupDto = JSON.parse(value);

            setResponse(parsedResponse);
        }
    }

    if (!response) {
        return (
            <form>
                <Input value={value}
                       onChange={handleChange}
                       name="input"/>

                <Button name="submit" onClick={onSubmit} type="submit">Submit</Button>
            </form>
        );
    } else {
        return (
            <div id="diagnostic-results">
                <TpiGroupGauge tpi={response}/>
            </div>
        )
    }
}


export default AutomatedTpiGroupResult;
